import apiClient from '../client'
import type { MaintenanceStatus } from './types'

export const maintenanceApi = {
  /** メンテナンス状態の取得（認証不要・ログイン前後どちらからでも呼べる）。 */
  status() {
    return apiClient.get<MaintenanceStatus>('/api/public/maintenance', { _silent: true })
  },

  /** メンテナンスモードの切替（deploy 管理者のみ。バックエンドでログイン ID を検証）。 */
  setEnabled(enabled: boolean, message?: string) {
    return apiClient.put<MaintenanceStatus>(
      '/api/admin/maintenance',
      { enabled, message },
      { _silent: true },
    )
  },
}
